import gql from 'graphql-tag';

import type { NotificationResponse } from 'common/components/NotificationsWidget/queries';
import { NotificationFragment } from 'common/components/NotificationsWidget/queries';

export const SUBSCRIBED_NOTIFICATIONS_PAGE_SIZE = 20;

export const getSubscribedNotifications = gql`
  query getSubscribedNotifications($id: [ID!], $fetch: Boolean!, $sync: Boolean!) {
    me {
      id
      notifications: recentNotifications(acknowledged: false, limit: 20) @include(if: $fetch) {
        ...Notification
      }

      sync: notifications(id: $id) @include(if: $sync) {
        ...Notification
      }
    }
  }

  ${NotificationFragment}
`;

export type SubscribedNotificationsResponse = {
  me: {
    notifications: NotificationResponse[];
    sync: NotificationResponse[];
  };
};
